export default __webpack_public_path__ + "static/media/ic-fert-line.6c0c312b.svg";